import { render, staticRenderFns } from "./MainLogo.vue?vue&type=template&id=5cd09311&scoped=true&"
import script from "./MainLogo.vue?vue&type=script&lang=js&"
export * from "./MainLogo.vue?vue&type=script&lang=js&"
import style0 from "./MainLogo.vue?vue&type=style&index=0&id=5cd09311&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd09311",
  null
  
)

export default component.exports